import React, { useState } from "react";
import profilePic from "../assets/images/profile.png";
// import Portfolio from "./Portfolio";
import Projects from './Projects';
import Certificate from "./Certificate";

// const displayPortfolio = () => {
//   return (
//   <Portfolio />
//   )
// }
const Main = () => {
  const [projectsClicked, setProjectsClicked] = useState(false);
  const [certificateClicked, setCertificateClicked] = useState(false);


  return (
    <>
      <main
        className={
          projectsClicked || certificateClicked
            ? "main-padding"
            : "align-center"
        }
      >
        <div className="profile">
          <div className="profile-image">
            <img src={profilePic} alt="" />
          </div>
          <div className="card-content">
            <div className="details">
              <div className="title">
                <h1>Saman Zahedi</h1>
                <p>JUNIOR SOFTWARE DEVELOPER</p>
              </div>
              <div className="link">
                <p>
                  <a
                    href="mailto:saman.zahedi10@gmail.com"
                    target="_blank"
                    rel="noreferrer"
                    title="saman.zahedi10@gmail.com"
                  >
                    <i class="fa-solid fa-envelope"></i>
                    saman.zahedi10@gmail.com
                  </a>
                </p>
                <p>
                  <a
                    href="https://www.linkedin.com/in/saman-zahedi/"
                    target="new window"
                    title="linkedin.com/in/saman-zahedi"
                  >
                    <i class="fa-brands fa-linkedin"></i>
                    linkedin.com/in/saman-zahedi
                  </a>
                </p>
                <p>
                  <a
                    href="https://github.com/SamanZahedi"
                    target="new window"
                    title="github.com/SamanZahedi"
                  >
                    <i class="fa-brands fa-github-square"></i>
                    github.com/SamanZahedi
                  </a>
                </p>
                <p>
                  <a
                    href="https://www.facebook.com/saman.zahedi.58"
                    target="new window"
                    title="facebook.com/saman.zahedi.58"
                  >
                    <i class="fa-brands fa-facebook-square"></i>
                    facebook.com/saman.zahedi.58
                  </a>
                </p>
                <p>
                  <a
                    href="https://twitter.com/Saman7479"
                    target="new window"
                    title="twitter.com/Saman7479"
                  >
                    <i class="fa-brands fa-twitter-square"></i>
                    twitter.com/Saman7479
                  </a>
                </p>
              </div>
            </div>
            <footer>
              <a
                href="#project_id"
                onClick={() => {
                  setProjectsClicked(!projectsClicked);
                  setCertificateClicked(false);
                }}
              >
                Projects
              </a>
              <a
                href="#cert_id"
                onClick={() => {
                  setProjectsClicked(false);
                  setCertificateClicked(!certificateClicked);
                }}
              >
                Certificates
              </a>
              <a href={require("../assets/Saman_Zahedi_Resume.pdf")} download>
                Download CV
              </a>
            </footer>
          </div>
        </div>
      </main>
      <contain
        className={(projectsClicked || certificateClicked) && "contain-clicked"}
      >
        {projectsClicked && <Projects />}
        {certificateClicked && <Certificate />}
      </contain>
    </>
  );
};

export default Main;
